<template>
<div class="px-4 sm:px-8 lg:px-0">
    <div class="mx-auto my-12 w-full max-w-2xl bg-white rounded-lg shadow-md p-6 sm:p-12">
        <div class="flex flex-col gap-4 py-8">
            <h1 class="text-center font-bold text-2xl">アカウントの作成が完了しました！</h1>
            <p class="text-sm line-heo">
                Youtubeチャンネルオーナーの方は、引き続きチャンネル登録を進めてください。
            </p>
            <p class="text-sm line-heo">
                オーナーでない方は、オーナーに招待を依頼してください。
            </p>
        </div>
        <div class="flex flex-col gap-2.5">
            <router-link to="/channel-creation" class="w-full text-center btn-lg btn-primary text-white" type="button">
                チャンネル登録に進む
            </router-link>
            <router-link to="/channel-invitation" type="link" class="flex justify-center">
                <span class="text-center text-blue-600 font-light">招待を待つ</span>
            </router-link>
        </div>
    </div>
        </div>
</template>

<script setup>
</script>
